export default __webpack_public_path__ + "static/media/delivery.1adf8069.svg";